import React, { useEffect, useState } from 'react';

const MagicDust = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const createParticle = () => {
      const id = Math.random();
      const particle = {
        id,
        left: Math.random() * 100,
        animationDuration: 8 + Math.random() * 12,
        animationDelay: Math.random() * 5,
        size: 2 + Math.random() * 4,
      };
      return particle;
    };

    const initialParticles = Array.from({ length: 15 }, createParticle);
    setParticles(initialParticles);

    const interval = setInterval(() => {
      setParticles(prev => {
        const newParticles = [...prev];
        const indexToReplace = Math.floor(Math.random() * newParticles.length);
        newParticles[indexToReplace] = createParticle();
        return newParticles;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-10">
      {particles.map(particle => (
        <div
          key={particle.id}
          className="magic-particle"
          style={{
            left: `${particle.left}%`,
            bottom: '-10px',
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            animationDuration: `${particle.animationDuration}s`,
            animationDelay: `${particle.animationDelay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default MagicDust;
